export default __webpack_public_path__ + "static/media/playerpg.dd190b6b.png";